<template>
  <div>
    <u-loader v-if="isLoading" />
    <div v-else>
      <u-error-handling
        v-if="errorObject"
        class="mt-4"
        :error-object="errorObject"
      />
      <h5>Mindestlohnkonfiguration des Hauptvertrags verwenden</h5>
      <div class="row p-2">
        <div class="col-1">
          <p class="defaultLabel">
            Hauptvertrag verwenden:
          </p>
        </div>
        <div class="col-1">
          <b-check
            v-model="useMainContractEdition"
            class="mt-0"
            :disabled="!canUserEdit"
          />
        </div>
        <div class="col-1">
          <p class="defaultLabel">
            Tenants:
          </p>
        </div>
        <div class="col-2">
          <div
            v-for="(tenant, tenantindex) in tenantOptions"
            :key="tenantindex"
          >
            <b-check
              :checked="selectedTenants.includes(tenant.id)"
              :disabled="!useMainContractEdition || !canUserEdit"
              @change="handleTenantSelectionChange(tenant.id)"
            >
              {{ tenant.name }}
            </b-check>
          </div>
        </div>
        <div class="col-1">
          <p class="defaultLabel">
            Edition:
          </p>
        </div>
        <div class="col-5">
          <v-select
            v-model="selectedMainContractEdition"
            :items="mainContractEditions"
            item-text="name"
            item-value="id"
            :disabled="!useMainContractEdition || !canUserEdit"
            :clearable="true"
            class="pt-0 mt-0"
          />
        </div>
        <div class="col-1">
          <button
            v-b-tooltip.hover
            type="button"
            placement="bottom"
            title="Speichern"
            class="btn btn-success smallActionButton"
            :disabled="!canUserEdit"
            @click="updateEdition()"
          >
            <i class="fas fa-save" />
          </button>
          <button
            v-b-tooltip.hover
            type="button"
            placement="bottom"
            title="Abbrechen"
            class="btn btn-danger smallActionButton ml-2"
            :disabled="!canUserEdit"
            @click="cancel()"
          >
            <i class="fas fa-times" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetSupplementaryContractEditions } from "@/services/contract.service.js";
import {
  GetSinlgeEdition,
  SaveEditionInformation,
} from "@/services/contract.edition.service.js";

export default {
  name: "EditionSupplementaryContract",
  props: {
    contractNumber: {
      type: String,
      required: true,
    },
    versionId: {
      type: Number,
      required: true,
    },
    editionId: {
      type: Number,
      required: true,
    },
    canUserEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mainContractEditions: [],
      selectedMainContractEdition: null,
      useMainContractEdition: false,
      selectedTenants: [],
      editionDetails: null,
      editionStateLabels: {
        1: "EDIT",
        3: "AKTUALISIERT",
        4: "SUPERSEDED",
        5: "DEACTIVATED",
      },
      tenantOptions: [
        { id: 1, name: "gav-service.ch" },
        { id: 2, name: "tempdata.ch" },
        { id: 3, name: "seco" },
        { id: 4, name: "Unia" },
      ],
      isLoading: false,
      errorObject: null,
    };
  },
  created() {
    this.loadMainContractEditions();
    this.loadEdition();
  },
  methods: {
    handleTenantSelectionChange(tenantId) {
      let newTenantSelection = [...this.selectedTenants];
      if (newTenantSelection.includes(tenantId)) {
        newTenantSelection = newTenantSelection.filter((id) => id !== tenantId);
      } else {
        newTenantSelection.push(tenantId);
      }
      this.selectedTenants = newTenantSelection;
      this.$emit("tenantsChanged", this.selectedTenants);
    },
    loadMainContractEditions() {
      this.isLoading = true;
      GetSupplementaryContractEditions(
        this.contractNumber,
        (result) => {
          this.mainContractEditions = result.map((x) => {
            return {
              id: x.editionId,
              name: `${x.editionId} - ${x.versionNumber} (${this.editionStateLabels[x.editionState]} - ${x.editionCreatedBy})`,
            };
          });
          this.mainContractEditions.sort((a, b) => (a.id < b.id ? 1 : -1));
          this.isLoading = false;
        },
        (error) => {
          console.error("Error loading main contract editions:", error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    loadEdition() {
      this.isLoading = true;
      GetSinlgeEdition(
        this.contractNumber,
        this.versionId,
        this.editionId,
        (response) => {
          this.editionDetails = response;
          this.useMainContractEdition = response.mainContractEditionId !== null;
          this.selectedMainContractEdition = response.mainContractEditionId;
          if (
            response.mainContractTenants &&
            response.mainContractTenants.length > 0
          ) {
            this.selectedTenants = response.mainContractTenants.map(
              (x) => x.tenantId,
            );
          }
          this.isLoading = false;
        },
        (error) => {
          console.error("Error loading edition:", error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    updateEdition() {
      this.isLoading = true;
      var editionObject = { ...this.editionDetails };

      if (!this.useMainContractEdition) {
        editionObject.mainContractEditionId = null;
        editionObject.mainContractTenants = [];
        this.selectedTenants = [];
      } else {
        editionObject.mainContractEditionId = this.selectedMainContractEdition;
        editionObject.mainContractTenants = this.selectedTenants.map((x) => {
          return { editionId: this.editionId, tenantId: x };
        });
      }

      SaveEditionInformation(
        editionObject,
        this.contractNumber,
        this.versionId,
        () => {
          this.loadEdition();
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },

    cancel() {
      this.loadEdition();
    },
  },
};
</script>

<style scoped></style>
